import {Assert} from "js-vextensions";
import {CreateAccessor} from "mobx-graphlink";
import {ignore} from "mobx-sync";
import {O} from "web-vcore";
import {JournalState} from "../Store/main/journal.js";
import {ToolsState} from "../Store/main/tools.js";
import {DNDState} from "../UI/@Root/RootDragHandler.js";
import {pages} from "../Utils/URL/URLs.js";
import {TimingState} from "./main/@Special/Timing.js";
import {ContentState} from "./main/content.js";
import {EngineState} from "./main/engine.js";
import {CacheState} from "./main/general/CacheState.js";
import {CopiedData} from "./main/general/CopiedData.js";
import {MapsState} from "./main/maps.js";
import {MoreState} from "./main/more.js";
import {SettingsState} from "./main/settings.js";
import {StatsState} from "./main/stats.js";
import {TestingState} from "./main/testing.js";
import {TimelineState} from "./main/timeline.js";

// class is used only for initialization
export class MainState {
	// [immerable] = true;

	@O accessor page = "home";
	@O accessor urlExtraStr: string|n;
	@O accessor urlTestStr: string|n;

	@O accessor lastDBVersion: number; // tracks the last db-version the client started with, so we can know when we need to upgrade the store-data
	@O accessor envOverride: string|n;
	@O accessor dbOverride: string|n;
	@O accessor dbVersionOverride: string|n;

	@O accessor analyticsEnabled = true;
	@O accessor blockMobXUnsubscribing = false;
	@O accessor blockCacheClearing = false;
	@O accessor lastPageReloadIncompatibleAction: string|n; // gets read then cleared at app launch
	@O accessor copiedData = new CopiedData();

	/** ws failed because the browser rejects the app-server's TLS cert (normal on local clusters, which
	 * have no cert-manager). Drives the dev-only "accept the certificate" banner in the root UI. */
	@O @ignore accessor wsCertUntrusted = false;
	/** The origin of the app-server the websocket was trying to reach, computed when `wsCertUntrusted` was set. */
	@O @ignore accessor wsCertUntrustedURL: string|n;

	@O accessor dnd = new DNDState();
	@O accessor cache = new CacheState();
	@O accessor timing = new TimingState();

	// pages (and nav-bar panels)
	// ==========

	@O accessor testing = new TestingState();

	@O accessor more = new MoreState();
	@O accessor tools = new ToolsState();
	@O accessor engine = new EngineState();
	@O accessor timeline = new TimelineState();
	@O accessor home = {} as {subpage: string};
	@O accessor stats = new StatsState();
	@O accessor journal = new JournalState();
	@O accessor content = new ContentState();
	@O accessor maps = new MapsState();

	@O accessor settings = new SettingsState();
	@O accessor profile = {} as {subpage: string};

	@O @ignore accessor topLeftOpenPanel: string|n;
	@O @ignore accessor topRightOpenPanel: string|n;
}

// export type PageKey = "home" | ""
export const GetPage = CreateAccessor({ctx: 1}, function() {
	return this.store.main.page || "home";
});
export const GetSubpage = CreateAccessor({ctx: 1}, function() {
	const page = GetPage();
	Assert(this.store.main[page] && pages[page], `Cannot find state/info for page: ${page}`);
	return this.store.main[page].subpage as string || pages[page].DefaultChild;
});

export const TestStr = CreateAccessor({ctx: 1}, function() {
	return this.store.main.urlTestStr || "";
});
export const LHQFull = CreateAccessor({ctx: 1}, function() {
	//return TestStr() == "full"; 
	// this flag can be toggled by the user in the Settings->VR panel
	return this.store.main.tools.vr.scene_lhq.showFurniture;
});